import { Provider } from "react-redux";
import React, { Component } from "react";
import { Notify } from "react-redux-notify";
import { LocalizationProvider } from "@mui/lab";
import DateAdapter from "@mui/lab/AdapterDateFns";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider as StylesThemeProvider } from "@mui/styles";
import { ThemeProvider as MaterialThemeProvider, createTheme } from "@mui/material/styles";

import store from "./store";
import Base from "./components/Base";
import RootModal from "./components/helper/RootModal";
import StreamingSocket from "./helpers/contexts/streaming.jsx";
import Face2FaceSocket from "./helpers/contexts/face2face.jsx"; 
import SocketProvider from "./helpers/contexts/communication.jsx";
import NavigationProvider from './helpers/navigation/NavigationProvider.jsx';
import ViewWalletPopoverProvider from './hooks/context/viewWalletPopoverContext.jsx';

import "./App.css";
import "./dark.css";
import "../src/components/Modals/styles/F2FCallHistory.css"
import "react-redux-notify/dist/ReactReduxNotify.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import theme from "./theme/Theme.js";

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <BrowserRouter>
          <Face2FaceSocket>
          <SocketProvider>
            <StreamingSocket>
              <LocalizationProvider dateAdapter={DateAdapter}>
                <MaterialThemeProvider theme={theme}>
                  <StylesThemeProvider theme={theme}>
                    <RootModal />
                    <Notify />
                    <ViewWalletPopoverProvider>
                      <NavigationProvider>
                        <Base />
                      </NavigationProvider>
                    </ViewWalletPopoverProvider>
                  </StylesThemeProvider>
                </MaterialThemeProvider>
              </LocalizationProvider>
            </StreamingSocket>
          </SocketProvider>
          </Face2FaceSocket>
        </BrowserRouter>
      </Provider>
    );
  }
}

export default App;
